<template>
    <div class="home js">
        <div class="home-video">
            <video :src="bannerList?.file || require('@/assets/assetsNew/home/home.mp4')" :controls="false" muted loop
                autoplay playsinline webkit-playsinline></video>
            <div class="video-text">
                <h2 class="video-text-title" data-animate data-animate-order="1">{{ bannerList?.title }}</h2>
            </div>
        </div>
        <!-- About -->
        <div class="home-about">
            <div class="section-title animated fadeIn">
                <h2 class="section-title-text" data-animate data-animate-order="1">{{ aboutKomo?.title }}
                </h2>
            </div>
            <div class="about-content">
                <div class="content-left kb-enabled in-viewport">
                    <!-- <img src="@/assets/assetsNew/home/homeAbout.jpg"></img> -->
                    <img :src="aboutKomo?.img || require('@/assets/assetsNew/home/homeAbout.jpg')"></img>
                </div>
                <div class="content-right">
                    <div class="content-right-box">
                        <h2 class="content-right-title" data-animate data-animate-order="1">{{ aboutKomo?.content_title
                            }}</h2>
                        <h5 class="content-right-text" data-animate data-animate-order="2">
                            {{ aboutKomo?.conttent_content }}
                        </h5>
                        <div class="right-btn-box">
                            <!-- <div class="content-right-btn" data-animate data-animate-order="2">
                                MORE > >
                            </div> -->
                            <div class="content-right-btn" data-animate data-animate-order="2" @click="goToAbout">
                                {{ $t('home.oneCont.btn') }} >
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Treatments -->
        <div class="home-treatments">
            <div class="section-title">
                <h2 class="section-title-text">{{ treatmentsKomo?.title }}</h2>
            </div>
            <div class="treatments-content img-animate-up">
                <div class="item kb-animate-up animate-up">
                    <!-- <img src="@/assets/assetsNew/home/treatments1.png"></img> -->
                    <img :src="treatmentsKomo?.left_img || require('@/assets/assetsNew/home/treatments1.png')"></img>
                    <div class="content">
                        <div class="">
                            <h2 class="content-title">{{ treatmentsKomo?.left_img_title }}</h2>
                            <div class="content-btn" @click="goToTreatments">
                                {{ $t('new.learnMore') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item kb-animate-up animate-up">
                    <!-- <img src="@/assets/assetsNew/home/treatments2.png"></img> -->
                    <img :src="treatmentsKomo?.right_img || require('@/assets/assetsNew/home/treatments2.png')"></img>
                    <div class="content">
                        <div class="">
                            <h2 class="content-title">{{ treatmentsKomo?.right_img_title }}</h2>
                            <div class="content-btn" @click="goToTreatments">
                                {{ $t('new.learnMore') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item kb-animate-up animate-up">
                    <div class="content">
                        <div class="">
                            <h2 class="content-title">{{ treatmentsKomo?.content_title }}</h2>
                            <!-- <p class="content-text">
                                We blend science and refinement to restore balance from the roots. From scalp
                                purification to anti-aging, each ritual is personalized, effective, and deeply relaxing
                                — turning scalp wellness into a modern lifestyle.
                            </p> -->
                            <p v-html="treatmentsKomo?.conttent_content"></p>
                        </div>
                    </div>
                </div>
                <div class="item kb-animate-up animate-up">
                    <!-- <img src="@/assets/assetsNew/home/treatments3.png"></img> -->
                    <img :src="treatmentsKomo?.top_img || require('@/assets/assetsNew/home/treatments3.png')"></img>
                    <div class="content">
                        <div class="">
                            <h2 class="content-title">{{ treatmentsKomo?.top_img_title }}</h2>
                            <div class="content-btn" @click="goToTreatments">
                                {{ $t('new.learnMore') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item kb-animate-up animate-up">
                    <!-- <img src="@/assets/assetsNew/home/treatments4.png"></img> -->
                    <img :src="treatmentsKomo?.down_img || require('@/assets/assetsNew/home/t.webp')"></img>

                    <div class="content">
                        <div class="">
                            <h2 class="content-title">{{ treatmentsKomo?.down_img_title }}</h2>
                            <div class="content-btn" @click="goToTreatments">
                                {{ $t('new.learnMore') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Technology -->
        <div class="home-technology">
            <div class="section-title">
                <h2 class="section-title-text" data-animate data-animate-order="1">{{ technologyKomo?.title }}</h2>
            </div>
            <div class="home-technology-content">
                <swiper :options="technologySwiperOptions">
                    <swiper-slide v-for="(item, index) in technologyKomo?.content" :key="index" class="slide">
                        <img :src="item?.img" alt="" class="technology-swiper-img">
                        <div class="produtos-image-slideshow"></div>
                        <div class="technology-swiper-title">
                            <div class="title1" data-animate data-animate-order="1">
                                {{ item.content_title }}
                            </div>
                            <div v-if="item?.content_content" class="title2" data-animate data-animate-order="2">
                                {{ item.content_content }}
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <!-- Solves -->
        <div class="home-solves">

            <div class="section-title">
                <h2 class="section-title-text" data-animate data-animate-order="1">{{ resolveKomo?.title }}</h2>
            </div>
            <div class="home-solves-bg">
                <div class="home-solves-content kb-animate-swiper">
                    <div class="kb-animate-fade animate-fade">
                        <swiper :options="solvesSwiperOptions">
                            <swiper-slide v-for="(item, index) in resolveKomo?.content" :key="index" class="slide">
                                <img :src="item?.img" alt="" class="solves-swiper-img">
                                <div class="solves-swiper-title">
                                    <h3 class="title">
                                        {{ item?.img_title }}
                                    </h3>
                                </div>
                            </swiper-slide>
                            <!-- 左右箭头-->
                            <div slot="button-prev" class="swiper-button-prev solves-arrow prev"></div>
                            <div slot="button-next" class="swiper-button-next solves-arrow next"></div>
                        </swiper>
                    </div>
                </div>
            </div>

        </div>
        <!-- Stores -->
        <div class="home-stores">
            <div class="section-title">
                <h2 class="section-title-text" data-animate data-animate-order="1"> {{ $t('new.stores') }}</h2>
            </div>
            <div class="home-stores-content">
                <!-- <a href="/locations" class="home-stores-content kb-enabled in-viewport">
                    <img src="@/assets/assetsNew/home/stores.png"></img>
                </a> -->
                <router-link :to="'/locations'" style="text-decoration: none;">
                    <a class="home-stores-content kb-enabled in-viewport">
                        <img src="@/assets/assetsNew/home/stores.png"></img>
                    </a>
                </router-link>

            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getBannerListing, getDataList } from '@/api/komo'
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            bannerList: [],
            homeData: [],
            aboutKomo: {},
            treatmentsKomo: {},
            technologyKomo: {},
            resolveKomo: {},
            technologySwiperList: [
                {
                    img: require('@/assets/assetsNew/home/technology1.png'),
                    title1: 'Wash',
                    title2: 'KEMO Product Series',
                },
                {
                    img: require('@/assets/assetsNew/home/technology1.png'),
                    title1: 'Cleanse',
                },
                {
                    img: require('@/assets/assetsNew/home/technology2.png'),
                    title1: 'Nourish',
                },
                {
                    img: require('@/assets/assetsNew/home/technology3.png'),
                    title1: 'Care',
                },
                {
                    img: require('@/assets/assetsNew/home/technology4.png'),
                    title1: 'Treat',
                },
                {
                    img: require('@/assets/assetsNew/home/technology5.png'),
                    title1: 'Style',
                },
                {
                    img: require('@/assets/assetsNew/home/technology6.png'),
                    title1: 'Body',
                },
                {
                    img: require('@/assets/assetsNew/home/technology7.png'),
                    title1: 'Wash',
                },
            ],
            technologySwiperOptions: {
                initialSlide: 0,
                autoplay: {
                    delay: 10000, // 自动切换时间间隔
                    disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
                },
                loop: true, // 循环模式选项
            },
            solvesSwiperList: [
                {
                    img: require('@/assets/assetsNew/home/solves1.png'),
                    title: 'Alopecia'
                },
                {
                    img: require('@/assets/assetsNew/home/solves2.png'),
                    title: 'Greying'
                },
                {
                    img: require('@/assets/assetsNew/home/solves3.png'),
                    title: 'Inflammation'
                },
                {
                    img: require('@/assets/assetsNew/home/solves4.png'),
                    title: 'Dandruff'
                },
                {
                    img: require('@/assets/assetsNew/home/solves5.png'),
                    title: 'Grease'
                },
                {
                    img: require('@/assets/assetsNew/home/solves6.png'),
                    title: 'Damaged Hair'
                }

            ],
            solvesSwiperOptions: {
                initialSlide: 0,
                autoplay: {
                    delay: 10000, // 自动切换时间间隔
                    disableOnInteraction: true // 用户操作后是否停止自动切换，默认为true
                },
                loop: false, // 无限循环
                loopAdditionalSlides: 0, // 循环时额外复制的slide数量
                slideToClickedSlide: true, // 点击slide直接切换
                slidesPerView: 1.1, // 一次显示3个 slides
                spaceBetween: 10, // 设置 slides 之间的间距
                breakpoints: {
                    765: {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                    },
                },
                navigation: {
                    nextEl: '.solves-arrow.next',
                    prevEl: '.solves-arrow.prev',
                },
            }
        }
    },
    mounted() {

    },
    async created() {
        await this.initData();
    },
    methods: {
        goToAbout() {
            this.$router.push('/about');
        },
        goToTreatments() {
            this.$router.push('/solutions');
        },
        async initData() {
            try {
                const result = await getBannerListing('1');

                this.bannerList = result?.data?.list || [];
                console.log('Banner数据:', this.bannerList);
                const homeDatalist = await getDataList(1);
                this.homeData = homeDatalist?.data?.list;
                this.aboutKomo = this.homeData
                    .find(item => item.code === 'about_komo')
                    ?.value?.[0] ?? {};
                this.treatmentsKomo = this.homeData
                    .find(item => item.code === 'komo_solutions')
                    ?.value?.[0] ?? {};
                this.technologyKomo = this.homeData
                    .find(item => item.code === 'home_komo_technology')
                    ?.value?.[0] ?? {};
                this.resolveKomo = this.homeData
                    .find(item => item.code === 'resolve_specific_lssues')
                    ?.value?.[0] ?? {};
                console.log('homeData:', this.resolveKomo);
                this.initIntersectionObserver();
            } catch (error) {
                console.error('数据加载失败:', error);
                this.bannerList = [];
            }
        },
        // 加载动画
        initIntersectionObserver() {
            this.$nextTick(() => {
                // 获取所有需要观察的元素（包括图片和文字）
                const imageElements = this.$el.querySelectorAll('.kb-enabled');
                const textElements = this.$el.querySelectorAll('[data-animate]');
                const imgUpElemnts = this.$el.querySelectorAll('.img-animate-up .kb-animate-up');
                const imgFadeElemnts = this.$el.querySelectorAll('.kb-animate-swiper .kb-animate-fade');
                const allElements = [...imageElements, ...textElements, ...imgUpElemnts, ...imgFadeElemnts];
                // const allElements = [...textElements];
                if (allElements.length > 0) {
                    // 移除所有元素的初始动画类
                    imageElements.forEach(element => {
                        element.classList.remove('in-viewport');
                    });
                    textElements.forEach(element => {
                        element.classList.remove('animate-trigger');
                    });

                    imgUpElemnts.forEach(element => {
                        element.classList.remove('in-viewport');
                    });
                    imgFadeElemnts.forEach(element => {
                        element.classList.remove('in-viewport');
                    });
                    // 创建交叉观察器
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            const element = entry.target;

                            if (entry.isIntersecting) {
                                // 元素进入视口
                                // 如果是图片元素
                                if (element.classList.contains('kb-enabled')) {
                                    element.classList.add('in-viewport');
                                }
                                // 如果是文字元素
                                if (element.hasAttribute('data-animate')) {
                                    // 添加动画触发类
                                    element.classList.add('animate-trigger');
                                }
                                if (element.classList.contains('kb-animate-up')) {
                                    element.classList.add('in-viewport');
                                }
                                if (element.classList.contains('kb-animate-fade')) {
                                    element.classList.add('in-viewport');
                                }
                            } else {
                                // 元素离开视口（支持重复动画）
                                if (element.classList.contains('kb-enabled')) {
                                    element.classList.remove('in-viewport');
                                } else if (element.hasAttribute('data-animate')) {
                                    element.classList.remove('animate-trigger');
                                } else if (element.classList.contains('kb-animate-up')) {
                                    element.classList.remove('in-viewport');
                                } else if (element.classList.contains('kb-animate-fade')) {
                                    element.classList.remove('in-viewport');
                                }
                            }
                        });
                    }, {
                        threshold: 0.1, // 当10%的元素可见时触发
                        rootMargin: '0px 0px -50px 0px' // 提前50px触发
                    });

                    // 开始观察所有元素
                    allElements.forEach(element => {
                        observer.observe(element);
                    });
                }
            });
        },
    }
}

</script>
<style scoped lang="scss">
.home {}

/* HOME VIDEO 开始*/
.home-video {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.home-video video {
    width: 100%;
    height: 100%;
    // height: 100vh;
    object-fit: cover;
    /* 关键：保持比例、填满容器 */
    display: block;
}

.home-video .video-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

}

.video-text-title {
    font-size: 24px;
    font-family: "Crimson Text", serif;
    color: #ffffff;
    font-weight: 400;
    white-space: nowrap;
    font-style: normal;
    letter-spacing: -0.01em;
    text-transform: normal;
    line-height: 1.2;
    opacity: 0;
    transform: translateY(40px);
    /* 2. 让它 1.2 s 内回到原位 */
    animation: slideUp 1.2s ease forwards;
}

@keyframes slideUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 765px) {
    .video-text-title {
        font-size: 16px;
    }
}

/* Home About 开始*/
.home-about {
    width: 100%;
}

.home-about .about-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    // height: 950px;
}

.home-about .about-content .content-left {
    flex: 1;
    height: 100%;
    overflow: hidden;
    height: 50vw;
}

.home-about .about-content .content-left img {
    height: 100%;
    /* 高度完全展示 */
    width: 100%;
    /* 宽度随比例自动 */
    // object-fit: cover;
}


.home-about .about-content .content-right {
    flex: 1;
    height: 100%;
    background-color: #64715d;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vw;
    /* padding: 0 60px; */
}

.home-about .about-content .content-right .content-right-box {
    width: 75%;
    color: #e8e2d9;
}

.home-about .about-content .content-right .content-right-box .content-right-title {
    font-size: 28px;
    font-family: var(--header-font-stack);
    // margin: 0;
}

.home-about .about-content .content-right .content-right-box .content-right-text {
    font-size: 15px;
    font-family: var(--body-font-stack);
}

.home-about .about-content .content-right .content-right-box .content-right-btn {
    margin-top: 10px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    background: #422b20;
    border-radius: 40px;
    text-align: center;
    color: #e8e2d9;
    font-family: var(--body-font-stack);
    font-size: 14px;

    position: relative;
    /* 关键：让伪元素相对它定位 */
    overflow: hidden;
    /* 可选：把超出的光带隐藏得更干净 */
    cursor: pointer;
    transition: background .3s;
    /* 顺手加个背景色过渡 */
}

.home-about .about-content .content-right .content-right-box .content-right-btn::after {
    content: '';
    position: absolute;
    top: 0;
    left: 150%;
    width: 200%;
    height: 100%;
    background: linear-gradient(90deg,
            transparent,
            hsla(0, 0%, 100%, .25),
            transparent);
    transform: skew(-20deg);
    pointer-events: none;
    transition: left .6s ease-out;
}

.home-about .about-content .content-right .content-right-box .content-right-btn:hover::after {
    left: -150% !important;
    /* 保险写法；如仍无效，继续看下面 */
}

@media (max-width: 765px) {
    .home-about {
        .about-content {
            display: flex;
            flex-direction: column;

            .content-left {
                height: 100vw;
            }

            .content-right {
                margin-top: 0px;
                height: auto;
                padding: 10px 0;
                text-align: center;
            }
        }
    }

    .right-btn-box {
        display: flex;
        justify-content: center;
    }
}

/* Home About 结束 */
/* Home Treatments 开始 */
.treatments-content {
    padding: 0 60px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 5px;

    .item {
        overflow: hidden;
        position: relative;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }

        .content {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 30px;
            display: flex;
            justify-content: flex-end;
            /* 水平靠右 */
            align-items: flex-end;
            /* 垂直靠下 */
        }

        .content-title {
            color: #ffffff;
            font-size: 30px;
            font-family: var(--header-font-stack);
            text-align: right;
        }

        .content-btn {
            margin-top: 10px;
            width: 180px;
            height: 40px;
            line-height: 40px;
            background: #422b20;
            border-radius: 40px;
            text-align: center;
            color: #e8e2d9;
            font-family: var(--body-font-stack);
            font-size: 14px;

            position: relative;
            /* 关键：让伪元素相对它定位 */
            overflow: hidden;
            /* 可选：把超出的光带隐藏得更干净 */
            cursor: pointer;
            transition: background .3s;
            /* 顺手加个背景色过渡 */
        }

        .content-btn::after {
            content: '';
            position: absolute;
            top: 0;
            left: 150%;
            width: 200%;
            height: 100%;
            background: linear-gradient(90deg,
                    transparent,
                    hsla(0, 0%, 100%, .25),
                    transparent);
            transform: skew(-20deg);
            pointer-events: none;
            transition: left .6s ease-out;
        }

        .content-btn:hover::after {
            left: -150% !important;
            /* 保险写法；如仍无效，继续看下面 */
        }
    }



    .item:nth-child(1) {
        grid-column: span 3;
        height: 30vw;
    }

    .item:nth-child(2) {
        grid-column: span 3;
        height: 30vw;
    }

    .item:nth-child(3) {
        grid-column: span 2;
        height: 40vw;
        background: #223d33;

        .content {
            align-items: center;
            justify-content: flex-start;

            h2 {
                text-align: left;
            }

            p {
                color: #ffffff;
                font-size: 15px;
                font-family: var(--body-font-stack);
            }
        }
    }

    .item:nth-child(4) {
        grid-column: span 2;
        height: 40vw;
    }

    .item:nth-child(5) {
        grid-column: span 2;
        height: 40vw;

        img {
            // transform: scaleX(-1);
        }
    }


}

@media (max-width: 765px) {
    .treatments-content {
        grid-template-columns: 1fr;
        padding: 0 15px;

        .item:nth-child(1) {
            height: 60vw;
        }

        .item:nth-child(2) {
            height: 60vw;

            .content {
                align-items: flex-start;
                justify-content: flex-start;

                .content-title {
                    text-align: left;
                    font-size: 22px;
                }
            }
        }

        .item:nth-child(3) {
            height: 60vw;
            padding: 10px 0;
        }

        .item:nth-child(4) {
            height: 100vw;
        }

        .item:nth-child(5) {
            height: 100vw;
        }

    }


}

@media (max-width: 300px) {
    .treatments-content {
        grid-template-columns: 1fr;
        padding: 0 15px;

        .item:nth-child(3) {
            height: 100vw;
            padding: 10px 0;
        }




    }
}

/* Home Treatments 结束 */

/* Home Technology 开始 */
.home-technology-content {
    .slide {
        position: relative;

        .technology-swiper-img {
            width: 100%;
            height: 55vw;
        }

        .produtos-image-slideshow {
            background: linear-gradient(180deg,
                    rgba(0, 0, 0, 0.2) 50%,
                    rgba(0, 0, 0, 0.6));
            z-index: 0;
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
        }

        .technology-swiper-title {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            padding: 60px;

            .title1 {
                color: #ffffff;
                font-size: 60px;
                font-family: var(--header-font-stack);
            }

            .title2 {
                color: #ffffff;
                font-size: 24px;
                font-family: var(--body-font-stack);
            }
        }
    }

}

@media (max-width: 765px) {
    .home-technology-content {
        .slide {
            .technology-swiper-img {
                width: 100%;
                object-fit: cover;
            }

            .technology-swiper-title {
                padding: 15px;

                .title1 {
                    font-size: 36px;
                }

                .title2 {
                    font-size: 16px;
                }
            }

        }
    }

}

/* Home Technology 结束 */
/* Home Solves 开始 */
.home-solves {
    .home-solves-bg {
        padding: 0 60px 60px 60px;
    }

    .home-solves-content {
        max-width: 1600px;
        margin: 0 auto;
        // padding: 0 60px 60px 60px;
        position: relative;
        overflow: hidden;

        .slide {
            width: 100%;
            // height: 22vw;
            position: relative;
        }

        .solves-swiper-img {
            width: 100%;
            height: 100%;
        }

        .solves-swiper-title {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 15px;
            display: flex;
            align-items: flex-end;

            .title {
                font-size: 25px;
                font-family: var(--header-font-stack);
                color: #ffffff;
            }
        }

        .solves-arrow {
            width: 40px;
            height: 40px;
            background: #422b20;
            /* 可点击时的背景色 */
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background .25s;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0;
            /* 默认隐藏 */
            visibility: hidden;
            /* 同时把鼠标事件也藏起来 */
            transition: opacity .3s ease, visibility .3s ease, transform .4s ease;
            z-index: 10;
            overflow: hidden;
        }

        .solves-arrow::after {
            font-size: 16px;
            color: #fff;
            /* 箭头白色 */
        }

        .solves-arrow.swiper-button-disabled {
            background: #422b2050;
        }

        .solves-arrow.prev {
            left: 10px;
            transform: translateY(-50%) translateX(-60px);

            &:hover::before {
                background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
                content: "";
                height: 100%;
                left: -200%;
                position: absolute;
                top: 0;
                transform: skew(-20deg);
                width: 200%;
                animation: shineAgainLeft .75s cubic-bezier(.01, .56, 1, 1);
            }

            /* 完全藏到左边 */
        }

        .solves-arrow.next {
            right: 10px;
            transform: translateY(-50%) translateX(60px);

            &:hover::before {
                background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
                content: "";
                height: 100%;
                right: -200%;
                position: absolute;
                top: 0;
                transform: skew(-20deg);
                width: 200%;
                animation: shineAgainRight .75s cubic-bezier(.01, .56, 1, 1);
            }

            /* 完全藏到右边 */
        }


    }

    .home-solves-content:hover .solves-arrow {
        opacity: 1;
        visibility: visible;
    }

    .home-solves-content:hover .solves-arrow.prev {
        transform: translateY(-20%) translateX(30px);
    }

    .home-solves-content:hover .solves-arrow.next {
        transform: translateY(-20%) translateX(-30px);
    }

    @media (max-width: 765px) {
        .home-solves-bg {
            padding: 15px;
        }

        .home-solves-content {
            // padding: 15px;

            .slide {
                width: 100%;
            }

            .solves-arrow {
                display: none;
            }
        }

    }

}

/* Home Solves 结束 */

/* Home Stores 开始 */
.home-stores {
    .home-stores-content {
        // width: 100%;
        max-width: 100vw;
        height: 45vw;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

@media (max-width: 765px) {
    .home-stores {
        .home-stores-content {
            width: 100%;
            height: 70vw;
            // min-height: 500px;
            overflow: hidden;
            position: relative;
            padding: 0 0 40px;

            img {
                height: 100%;
                width: 100%;
                transform: translateX(-20%);
                object-fit: contain;
            }
        }
    }
}

/* Home Stores 结束 */

.kb-enabled {
    overflow: hidden;
}

/* 图片动画 - 从大变小 */
.kb-enabled>* {
    transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
    transform-origin: left center;
    transition: transform 2s ease;
}

/* 添加延迟，确保动画触发 */
.kb-enabled.in-viewport>* {
    animation: scaleDown 2s ease forwards;
    transform-origin: left center;
}

@keyframes scaleDown {
    from {
        transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
        transform-origin: left center;
    }

    to {
        transform: translate3d(0, 0, 0) scale(1);
        transform-origin: left center;
    }
}

/* 图片动画 - 从下到上 */
.animate-up {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.8s ease, transform 0.8s ease;
}

.kb-animate-up.in-viewport.animate-up {
    opacity: 1;
    transform: translateY(0);
}

.img-animate-up .item:nth-child(1) {
    transition-delay: 0s;
}

.img-animate-up .item:nth-child(2) {
    transition-delay: 0.15s;
}

.img-animate-up .item:nth-child(3) {
    transition-delay: 0.3s;
}

.img-animate-up .item:nth-child(4) {
    transition-delay: 0.45s;
}

.img-animate-up .item:nth-child(5) {
    transition-delay: 0.6s;
}

/* 图片动画 - 从左到右 渐变 */
.animate-fade {
    opacity: 0;
    transition: opacity 2s cubic-bezier(0.4, 0, 1, 1);
}

.kb-animate-fade.in-viewport.animate-fade {
    opacity: 1;
}
</style>